<div class="dl-page">
  <!-- Header -->
  <button type="button" class="dl-page__back" (click)="goBack()">
    <mat-icon>chevron_left</mat-icon>
    Back to partners
  </button>

  <div class="dl-page__header">
    <div class="dl-page__heading">
      <h1 class="dl-page__title" *ngIf="partner">{{ partner.contact?.name || 'Unknown Partner' }}</h1>
      <h1 class="dl-page__title" *ngIf="!partner && !loading">Partner details</h1>
      <div class="pd-badges" *ngIf="partner && !loading">
        <span class="partner-type" [class]="'type-' + (partner.type || 'unknown').toLowerCase()">
          {{ getPartnerTypeLabel() }}
        </span>
        <span class="tenant-badge tenant-yes" *ngIf="partner.isTenant">Tenant</span>
        <span class="pd-id" *ngIf="partner.id">ID {{ partner.id }}</span>
      </div>
    </div>
    <div class="dl-page__actions" *ngIf="partner && !loading">
      <span class="pd-verified" *ngIf="partner.isTenant">
        <mat-icon>verified</mat-icon>
        Verified
      </span>
      <div class="pd-tenant-actions" *ngIf="!partner.isTenant">
        <label class="dl-field__label" for="tenantCurrency">Currency</label>
        <select
          id="tenantCurrency" class="dl-select"
          [(ngModel)]="selectedTenantCurrency"
          [disabled]="tenantCreationLoading">
          <option *ngFor="let currency of availableCurrencies" [ngValue]="currency">
            {{ currency }}
          </option>
        </select>
        <button type="button" class="dl-btn dl-btn--primary" (click)="createTenant()" [disabled]="tenantCreationLoading">
          <mat-icon *ngIf="!tenantCreationLoading">domain_add</mat-icon>
          <mat-icon *ngIf="tenantCreationLoading" class="pd-spin">hourglass_empty</mat-icon>
          {{ tenantCreationLoading ? 'Creating...' : 'Create a tenant' }}
        </button>
      </div>
      <button type="button" class="dl-btn" *ngIf="partner.isTenant" (click)="openImport()">
        <mat-icon>upload_file</mat-icon>
        Import data
      </button>
      <button type="button" class="dl-btn dl-btn--primary" (click)="editPartner()">
        <mat-icon>edit</mat-icon>
        Edit Partner
      </button>
    </div>
  </div>

  <!-- Loading indicator -->
  <div *ngIf="loading" class="dl-loading">
    <div class="dl-spinner"></div>
    <p>Loading partner details…</p>
  </div>

  <!-- Error message -->
  <div *ngIf="error" class="dl-banner dl-banner--error">
    <mat-icon>error</mat-icon>
    <div class="dl-banner__body">{{ error }}</div>
    <div class="dl-banner__actions">
      <button type="button" class="dl-btn dl-btn--sm" (click)="goBack()">Back</button>
    </div>
  </div>

  <!-- Partner details -->
  <div *ngIf="partner && !loading && !error" class="partner-details">
    
    <!-- Tabs Navigation -->
    <div class="dl-card pd-tabs-card">
      <div class="pd-tabs" role="tablist">
        <button 
          class="pd-tab" type="button" role="tab" 
          [class.is-active]="activeTab === 'basic'"
          (click)="setActiveTab('basic')">
          <mat-icon>info</mat-icon>
          Basic Information
        </button>
        <button 
          class="pd-tab" type="button" role="tab" 
          [class.is-active]="activeTab === 'connections'"
          (click)="setActiveTab('connections')">
          <mat-icon>account_tree</mat-icon>
          Connections
        </button>
        <button 
          class="pd-tab" type="button" role="tab" 
          [class.is-active]="activeTab === 'users'"
          (click)="setActiveTab('users')">
          <mat-icon>people</mat-icon>
          Users
        </button>
        <button 
          class="pd-tab" type="button" role="tab" 
          [class.is-active]="activeTab === 'cases'"
          (click)="setActiveTab('cases')"
          *ngIf="shouldShowCases()">
          <mat-icon>folder</mat-icon>
          Cases
        </button>
        <button 
          class="pd-tab" type="button" role="tab" 
          [class.is-active]="activeTab === 'cases'"
          (click)="setActiveTab('cases')"
          *ngIf="shouldShowShipments()">
          <mat-icon>local_shipping</mat-icon>
          Shipments
        </button>
      </div>

      <!-- Tab Content -->
      <div class="pd-tab-content">
        
        <!-- Basic Information Tab -->
        <div *ngIf="activeTab === 'basic'" class="pd-tab-panel">
          <!-- Basic Information Card -->
          <div class="dl-card pd-card">
            <div class="dl-card__header">
              <h2 class="dl-card__title">Basic Information</h2>
            </div>
            <div class="dl-kv">
              <div class="dl-kv__item">
                <span class="dl-kv__key">Partner ID</span>
                <span class="dl-kv__value">{{ partner.id || 'N/A' }}</span>
              </div>
              <div class="dl-kv__item">
                <span class="dl-kv__key">Partner Logo</span>
                <div class="logo-display">
                  <!-- Logo Loading -->
                  <div *ngIf="logoLoading" class="logo-loading">
                    <div class="dl-spinner"></div>
                    <span>Loading logo...</span>
                  </div>
                  
                  <!-- Logo Error -->
                  <div *ngIf="logoError && !logoLoading" class="logo-error">
                    <mat-icon>error</mat-icon>
                    <span>{{ logoError }}</span>
                  </div>
                  
                  <!-- Logo Success -->
                  <img 
                    *ngIf="logoBlobUrl && !logoLoading && !logoError" 
                    [src]="logoBlobUrl" 
                    [alt]="partner.contact?.name + ' logo'"
                    class="partner-logo-large">
                  
                  <!-- No Logo -->
                  <div *ngIf="!partner.logoAttachment?.url && !logoLoading && !logoError" class="no-logo-large">
                    <mat-icon>business</mat-icon>
                    <span>No logo uploaded</span>
                  </div>
                </div>
              </div>
              <div class="dl-kv__item">
                <span class="dl-kv__key">Partner Name</span>
                <span class="dl-kv__value">{{ partner.contact?.name || 'N/A' }}</span>
              </div>
              <div class="dl-kv__item">
                <span class="dl-kv__key">Partner Type</span>
                <span class="partner-type" [class]="'type-' + (partner.type || 'unknown').toLowerCase()">
                  {{ getPartnerTypeLabel() }}
                </span>
              </div>
            </div>
          </div>

          <!-- Subscription Card (tenants only) -->
          <div class="dl-card pd-card" *ngIf="partner.isTenant" data-testid="partner-subscription">
            <div class="dl-card__header">
              <h2 class="dl-card__title">Subscription</h2>
            </div>
            <p *ngIf="!subscription">Demo period, no plan.</p>
            <p *ngIf="subscription">
              {{ subscription.kind === 'FLEXIBLE' ? 'Flexible' : subscription.planName }},
              {{ subscription.billingPeriod === 'YEARLY' ? 'yearly' : 'monthly' }},
              €{{ subscription.price | number:'1.2-2' }} ·
              {{ subscription.paymentStatus === 'PAID' ? 'paid' : 'unpaid' }} ·
              until {{ subscription.periodEnd | date:'dd.MM.yyyy' }} ·
              <a routerLink="/subscriptions">Manage</a>
            </p>
          </div>

          <!-- Feature Flags Card (tenants only) -->
          <div class="dl-card pd-card" *ngIf="partner.isTenant">
            <div class="dl-card__header">
              <h2 class="dl-card__title">Feature Flags</h2>
            </div>

            <p *ngIf="subscription" data-testid="partner-flags-plan-warning">
              This tenant is on a plan: its next plan change or payment update overwrites flags set here for modules on the price list.
            </p>

            <div *ngIf="flagsLoading" class="flags-loading">
              <div class="dl-spinner"></div>
              <span>Loading feature flags...</span>
            </div>

            <div *ngIf="flagsError && !flagsLoading" class="flags-error">
              <mat-icon>error</mat-icon>
              <span>{{ flagsError }}</span>
            </div>

            <ng-container *ngIf="!flagsLoading && !flagsError">
              <div *ngIf="featureFlags.length === 0" class="no-flags">
                No feature flags available.
              </div>

              <div class="flags-list" *ngIf="featureFlags.length > 0">
                <div class="flag-row" *ngFor="let flag of featureFlags">
                  <span *ngIf="!hasSwitch(flag)">{{ flagLabel(flag.name) }}</span>
                  <label class="dl-switch" *ngIf="hasSwitch(flag)">
                    <input
                      type="checkbox"
                      [(ngModel)]="flagEdits[flag.name]"
                      [disabled]="flagsSaving">
                    <span class="dl-switch__track"></span>
                    <span class="dl-switch__label">{{ flagLabel(flag.name) }}</span>
                  </label>

                  <!-- Only the features that cost money per use have a dial. Leaving the box empty
                       is meaningful: it puts the tenant back on the free plan, which the
                       placeholder spells out. -->
                  <div class="flag-limit" *ngIf="isMetered(flag)">
                    <input
                      type="number"
                      min="0"
                      step="1"
                      [(ngModel)]="limitEdits[flag.name]"
                      (input)="onLimitInput(flag, $event)"
                      [class.is-invalid]="!limitValid(flag)"
                      [attr.aria-invalid]="!limitValid(flag)"
                      [placeholder]="freePlanPlaceholder(flag)"
                      [disabled]="flagsSaving"
                      [attr.aria-label]="flagLabel(flag.name) + ' monthly allowance'" />
                    <span class="flag-limit-unit">{{ unitLabel(flag) }}</span>
                    <small class="flag-limit-error" *ngIf="!limitValid(flag)">
                      Whole number, or empty for the free plan
                    </small>
                  </div>
                </div>
              </div>

              <div class="flags-actions" *ngIf="featureFlags.length > 0">
                <button
                  class="dl-btn dl-btn--primary"
                  (click)="saveFeatureFlags()"
                  [disabled]="flagsSaving || !canSaveFlags()">
                  <mat-icon *ngIf="!flagsSaving">save</mat-icon>
                  <mat-icon *ngIf="flagsSaving" class="pd-spin">hourglass_empty</mat-icon>
                  {{ flagsSaving ? 'Saving...' : 'Save' }}
                </button>
              </div>
            </ng-container>
          </div>

          <!-- Storage Card (tenants only). The limit is the File storage figure above: a total, never monthly. -->
          <div class="dl-card pd-card" *ngIf="partner.isTenant && storage" data-testid="storage-card">
            <div class="dl-card__header">
              <h2 class="dl-card__title">File Storage</h2>
            </div>
            <p data-testid="storage-usage" [attr.data-state]="storage.state">
              {{ formatGb(storage.usedBytes) }} used
              <ng-container *ngIf="storage.limitBytes !== null">of {{ formatGb(storage.limitBytes) }} in total</ng-container>
              <ng-container *ngIf="storage.limitBytes === null">· no limit</ng-container>
              · {{ storage.state }}
              <ng-container *ngIf="storage.blockedFrom">· uploads refused from {{ storage.blockedFrom | date:'dd.MM.yyyy' }}</ng-container>
            </p>
          </div>

          <!-- SMS Credit Card (tenants only). The monthly allowance is the FEATURE_SMS limit above. -->
          <div class="dl-card pd-card" *ngIf="partner.isTenant && smsCredit" data-testid="sms-credit-card">
            <div class="dl-card__header">
              <h2 class="dl-card__title">SMS Credit</h2>
            </div>
            <p>
              Available: <strong data-testid="sms-credit-available">{{ smsCredit.available }}</strong> ·
              Purchased balance: <strong data-testid="sms-credit-balance">{{ smsCredit.topUpBalance }}</strong> ·
              This month: {{ smsCredit.usedThisMonth }} of {{ smsCredit.monthlyAllowance }} used
            </p>
            <div class="flag-limit">
              <select [(ngModel)]="smsCreditReason" aria-label="Type of change" data-testid="sms-topup-reason">
                <option value="TOPUP">Top-up</option>
                <option value="ADJUST">Correction</option>
              </select>
              <input type="number" step="1" placeholder="Credits" aria-label="Credits"
                     [(ngModel)]="smsCreditAmount" data-testid="sms-topup-amount" />
              <input type="text" maxlength="255" placeholder="Note (optional)" aria-label="Note"
                     [(ngModel)]="smsCreditNote" data-testid="sms-topup-note" />
              <button class="dl-btn dl-btn--primary" (click)="changeSmsCredit()"
                      [disabled]="smsCreditSaving || !canChangeSmsCredit()" data-testid="sms-topup-submit">
                Apply
              </button>
            </div>
            <table *ngIf="smsLedger.length > 0" data-testid="sms-ledger">
              <tr *ngFor="let entry of smsLedger" data-testid="sms-ledger-row">
                <td>{{ entry.createdAt | date:'dd.MM.yyyy HH:mm' }}</td>
                <td>{{ entry.reason }}</td>
                <td>{{ entry.delta > 0 ? '+' : '' }}{{ entry.delta }}</td>
                <td>{{ entry.note }}</td>
              </tr>
            </table>
          </div>

          <!-- Contact Information Card -->
          <div class="dl-card pd-card">
            <div class="dl-card__header">
              <h2 class="dl-card__title">Contact Information</h2>
            </div>
            <div class="dl-kv">
              <div class="dl-kv__item" *ngIf="partner.contact?.email">
                  <span class="dl-kv__key">Email</span>
                  <span class="dl-kv__value">
                  <a [href]="'mailto:' + getContactEmail()" class="contact-link">
                    {{ getContactEmail() }}
                  </a>
                </span>
              </div>
              <div class="dl-kv__item" *ngIf="partner.contact?.phoneNumber">
                  <span class="dl-kv__key">Phone Number</span>
                  <span class="dl-kv__value">
                  <a [href]="'tel:' + getContactPhone()" class="contact-link">
                    {{ getContactPhone() }}
                  </a>
                </span>
              </div>
              <div class="dl-kv__item" *ngIf="partner.faxNo">
                  <span class="dl-kv__key">Fax Number</span>
                  <span class="dl-kv__value">
                  <a [href]="'tel:' + getFaxNo()" class="contact-link">
                    {{ getFaxNo() }}
                  </a>
                </span>
              </div>
              <div class="dl-kv__item" *ngIf="!partner.contact?.email && !partner.contact?.phoneNumber && !partner.faxNo">
                <app-empty-state icon="contact_phone">No contact information available</app-empty-state>
              </div>
            </div>
          </div>

          <!-- Address Information Card -->
          <div class="dl-card pd-card">
            <div class="dl-card__header">
              <h2 class="dl-card__title">Address Information</h2>
            </div>
            <div class="address-details">
              <div class="dl-kv__item pd-kv-wide" *ngIf="partner.contact?.address?.street || partner.contact?.address?.city || partner.contact?.address?.state || partner.contact?.address?.zip">
                <label>Full Address</label>
                <div class="address-block">
                  {{ getFormattedAddress() }}
                </div>
              </div>
              
              <div class="dl-kv" *ngIf="partner.contact?.address?.street || partner.contact?.address?.city || partner.contact?.address?.state || partner.contact?.address?.zip">
                <div class="dl-kv__item" *ngIf="partner.contact?.address?.street">
                  <span class="dl-kv__key">Street</span>
                  <span class="dl-kv__value">{{ getAddressStreet() }}</span>
                </div>
                <div class="dl-kv__item" *ngIf="partner.contact?.address?.city">
                  <span class="dl-kv__key">City</span>
                  <span class="dl-kv__value">{{ getAddressCity() }}</span>
                </div>
                <div class="dl-kv__item" *ngIf="partner.contact?.address?.state">
                  <span class="dl-kv__key">State</span>
                  <span class="dl-kv__value">{{ getAddressState() }}</span>
                </div>
                <div class="dl-kv__item" *ngIf="partner.contact?.address?.zip">
                  <span class="dl-kv__key">ZIP Code</span>
                  <span class="dl-kv__value">{{ getAddressZip() }}</span>
                </div>
              </div>

              <app-empty-state *ngIf="!partner.contact?.address?.street && !partner.contact?.address?.city && !partner.contact?.address?.state && !partner.contact?.address?.zip" icon="location_off">No address information available</app-empty-state>
            </div>
          </div>

          <!-- Bank Accounts Information Card -->
          <div class="dl-card pd-card" *ngIf="getBankAccounts().length > 0">
            <div class="dl-card__header">
              <h2 class="dl-card__title">Bank Accounts</h2>
            </div>
            <div class="bank-accounts-list">
              <div *ngFor="let bankAccount of getBankAccounts()" class="bank-account-item">
                <div class="bank-account-detail">
                  <label>Bank Name</label>
                  <span>{{ bankAccount.name || 'N/A' }}</span>
                </div>
                <div class="bank-account-detail">
                  <label>Account Number</label>
                  <span>{{ bankAccount.number || 'N/A' }}</span>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- Connections Tab -->
        <div *ngIf="activeTab === 'connections'" class="pd-tab-panel">
          <!-- Partner Connections Card -->
          <div class="dl-card pd-card">
            <div class="connections-header">
              <div class="dl-card__header">
              <h2 class="dl-card__title">Partner Connections</h2>
            </div>
              <button class="dl-btn dl-btn--primary" (click)="toggleAddConnectionForm()" [disabled]="connectionsLoading">
                <mat-icon *ngIf="!showAddConnectionForm">add</mat-icon>
                <mat-icon *ngIf="showAddConnectionForm">cancel</mat-icon>
                {{ showAddConnectionForm ? 'Cancel' : 'Add Connection' }}
              </button>
            </div>

            <!-- Add Connection Form -->
            <div *ngIf="showAddConnectionForm" class="add-connection-form">
              <h3>
                <mat-icon>add_circle</mat-icon>
                Add New Connection
              </h3>
              
              <div *ngIf="addConnectionError" class="dl-banner dl-banner--error">
                <mat-icon>error</mat-icon>
                {{ addConnectionError }}
              </div>

              <div class="dl-filters">
                <div class="dl-field">
                  <label for="partnerSearch">Search and Select Partner</label>
                  <app-searchable-selection
                    [items]="filteredPartners"
                    [displayProperty]="'contact.name'"
                    [displaySuffixProperty]="'type'"
                    [valueProperty]="'id'"
                    [searchProperties]="['contact.name', 'contact.email', 'contact.phoneNumber', 'type']"
                    [placeholder]="'Type to search partners...'"
                    [disabled]="addConnectionLoading"
                    [serverSideSearch]="true"
                    [selectedValue]="selectedPartner?.id"
                    (itemSelected)="onPartnerSelected($event)"
                    (valueSelected)="onPartnerValueSelected($event)"
                    (searchTermChange)="onPartnerSearchTermChange($event)">
                  </app-searchable-selection>
                </div>
              </div>

              <div class="pd-form-actions">
                <button class="dl-btn" (click)="toggleAddConnectionForm()" [disabled]="addConnectionLoading">
                  <mat-icon>cancel</mat-icon>
                  Cancel
                </button>
                <button type="button" class="dl-btn dl-btn--primary" (click)="addConnection()" [disabled]="addConnectionLoading || !selectedPartner">
                  <mat-icon *ngIf="!addConnectionLoading">add</mat-icon>
                  <mat-icon *ngIf="addConnectionLoading" class="pd-spin">hourglass_empty</mat-icon>
                  <span *ngIf="!addConnectionLoading">Add Connection</span>
                  <span *ngIf="addConnectionLoading">Adding...</span>
                </button>
              </div>
            </div>

            <!-- Connections Loading -->
            <div *ngIf="connectionsLoading" class="connections-loading">
              <div class="dl-spinner"></div>
              <p>Loading connections...</p>
            </div>

            <!-- Connections Error -->
            <div *ngIf="connectionsError" class="dl-banner dl-banner--error">
              <mat-icon>error</mat-icon>
              {{ connectionsError }}
            </div>

            <!-- Connections List -->
            <div *ngIf="!connectionsLoading && !connectionsError" class="connections-list">
              <app-empty-state *ngIf="connections.length === 0" icon="account_tree">No connections found for this partner.</app-empty-state>

              <div *ngIf="connections.length > 0" class="connections-table">
                <table class="dl-table dl-table--cards" dlCardTable>
                  <thead>
                    <tr>
                      <th>Connected Partner</th>
                      <th>Partner Type</th>
                      <th>Status</th>
                      <th>Created</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr *ngFor="let connection of connections">
                      <td class="partner-info">
                        <div class="partner-name">
                          <a 
                            *ngIf="connection.connectedPartner?.id" 
                            [routerLink]="['/partners', connection.connectedPartner?.id]" 
                            class="partner-link">
                            {{ connection.connectedPartner?.contact?.name || 'Unknown Partner' }}
                          </a>
                          <span *ngIf="!connection.connectedPartner?.id">
                            {{ connection.connectedPartner?.contact?.name || 'Unknown Partner' }}
                          </span>
                        </div>
                        <div class="partner-details">
                          {{ connection.connectedPartner?.contact?.email || '' }}
                        </div>
                      </td>
                      <td>
                        <span class="partner-type" [class]="'type-' + (connection.connectedPartner?.type || 'unknown').toLowerCase()">
                          {{ connection.connectedPartner?.type || 'Unknown' }}
                        </span>
                      </td>
                      <td>
                        <span class="connection-status" [class]="getConnectionStatusClass(connection.status || '')">
                          {{ connection.status || 'Unknown' }}
                        </span>
                      </td>
                      <td>
                        {{ connection.createdAt ? (connection.createdAt | date:'short') : 'N/A' }}
                      </td>
                    </tr>
                  </tbody>
                </table>
                </div>
              </div>
            </div>
          </div>

        <!-- Users Tab -->
        <div *ngIf="activeTab === 'users'" class="pd-tab-panel">
          <!-- Partner Users Card -->
          <div class="dl-card pd-card">
            <div class="connections-header">
              <div class="dl-card__header">
              <h2 class="dl-card__title">Partner Users</h2>
            </div>
              <!-- Users live in the Keycloak group /partners/{tenantId}, so only a tenant has
                   somewhere to put a new account. -->
              <button *ngIf="partner?.isTenant"
                      class="dl-btn dl-btn--primary"
                      (click)="toggleAddUserForm()"
                      [disabled]="usersLoading">
                <mat-icon *ngIf="!showAddUserForm">person_add</mat-icon>
                <mat-icon *ngIf="showAddUserForm">cancel</mat-icon>
                {{ showAddUserForm ? 'Cancel' : 'Add User' }}
              </button>
            </div>

            <!-- Add User Form -->
            <div *ngIf="showAddUserForm" class="add-user-form">
              <h3>
                <mat-icon>person_add</mat-icon>
                Add New User
              </h3>

              <div *ngIf="addUserError" class="dl-banner dl-banner--error">
                <mat-icon>error</mat-icon>
                {{ addUserError }}
              </div>

              <div class="dl-filters">
                <div class="dl-field">
                  <label for="userFirstName">First Name *</label>
                  <input type="text"
                         id="userFirstName"
                         [(ngModel)]="newUser.firstName"
                         name="userFirstName"
                         placeholder="Ana"
                         [disabled]="addUserLoading" />
                </div>

                <div class="dl-field">
                  <label for="userLastName">Last Name *</label>
                  <input type="text"
                         id="userLastName"
                         [(ngModel)]="newUser.lastName"
                         name="userLastName"
                         placeholder="Petrovic"
                         [disabled]="addUserLoading" />
                </div>

                <div class="dl-field">
                  <label for="userEmail">Email *</label>
                  <input type="email"
                         id="userEmail"
                         [(ngModel)]="newUser.email"
                         name="userEmail"
                         placeholder="ana@example.com"
                         [disabled]="addUserLoading" />
                  <small class="field-hint">This is also the username they sign in with.</small>
                </div>

                <div class="dl-field">
                  <label for="userRole">Role *</label>
                  <select id="userRole"
                          [(ngModel)]="newUser.role"
                          name="userRole"
                          [disabled]="addUserLoading">
                    <!-- [ngValue] rather than value, so the placeholder goes through the same
                         option map as the roles below and stays selected until one is picked. -->
                    <option [ngValue]="''" disabled>Select a role</option>
                    <option *ngFor="let role of assignableRoles" [ngValue]="role">
                      {{ getUserRoleLabel(role) }}
                    </option>
                  </select>
                </div>
              </div>

              <div class="pd-form-actions">
                <button class="dl-btn" (click)="toggleAddUserForm()" [disabled]="addUserLoading">
                  <mat-icon>close</mat-icon>
                  Cancel
                </button>
                <button type="button" class="dl-btn dl-btn--primary" (click)="createUser()" [disabled]="addUserLoading">
                  <mat-icon *ngIf="!addUserLoading">person_add</mat-icon>
                  <mat-icon *ngIf="addUserLoading" class="pd-spin">hourglass_empty</mat-icon>
                  <span *ngIf="!addUserLoading">Create User</span>
                  <span *ngIf="addUserLoading">Creating...</span>
                </button>
              </div>
            </div>

            <!-- The email belongs to somebody already. Asked rather than done: an admin can tell
                 a colleague who works for two organisations from a mistyped address. -->
            <div *ngIf="existingAccountEmail" class="temp-password-banner">
              <div class="temp-password-head">
                <mat-icon>person_search</mat-icon>
                <strong>{{ existingAccountEmail }} already has an account</strong>
              </div>
              <p class="temp-password-warning">
                Adding them puts that person into this tenant as
                {{ getUserRoleLabel(newUser.role) }}. They keep their existing password, and go on
                working in any other tenant they belong to.
              </p>
              <div class="temp-password-value">
                <button class="dl-btn dl-btn--primary dl-btn--sm"
                        [disabled]="addUserLoading"
                        (click)="confirmAddExistingAccount()">
                  <mat-icon>person_add</mat-icon>
                  Add to this tenant
                </button>
                <button class="dl-btn dl-btn--ghost dl-btn--sm"
                        [disabled]="addUserLoading"
                        (click)="cancelAddExistingAccount()">
                  <mat-icon>close</mat-icon>
                  Cancel
                </button>
              </div>
            </div>

            <!-- Added rather than created: there is no credential to hand over. -->
            <div *ngIf="addedExistingAccount" class="temp-password-banner">
              <div class="temp-password-head">
                <mat-icon>check_circle</mat-icon>
                <strong>{{ addedExistingAccount }} was added to this tenant</strong>
              </div>
              <p class="temp-password-warning">
                No password to pass on — they sign in with the one they already use.
              </p>
              <div class="temp-password-value">
                <button class="dl-btn dl-btn--ghost dl-btn--sm" (click)="dismissAddedExistingAccount()">
                  <mat-icon>close</mat-icon>
                  Dismiss
                </button>
              </div>
            </div>

            <!-- One-time credentials. The password is generated server-side and is not stored,
                 so once this is dismissed it cannot be recovered — only reset. -->
            <div *ngIf="createdUserCredentials" class="temp-password-banner">
              <div class="temp-password-head">
                <mat-icon>check_circle</mat-icon>
                <strong>Account created for {{ createdUserCredentials.email }}</strong>
              </div>
              <p class="temp-password-warning">
                This temporary password is shown <strong>once</strong> and cannot be retrieved later.
                Copy it now and pass it on — the user must change it at first sign-in.
              </p>
              <div class="temp-password-value">
                <code>{{ createdUserCredentials.password }}</code>
                <button class="dl-btn dl-btn--sm" (click)="copyTemporaryPassword()">
                  <mat-icon>content_copy</mat-icon>
                  Copy
                </button>
                <button class="dl-btn dl-btn--ghost dl-btn--sm" (click)="dismissTemporaryPassword()">
                  <mat-icon>close</mat-icon>
                  Dismiss
                </button>
              </div>
            </div>

            <!-- Users Loading -->
            <div *ngIf="usersLoading" class="users-loading">
              <div class="dl-spinner"></div>
              <p>Loading users...</p>
            </div>

            <!-- Users Error -->
            <div *ngIf="usersError" class="dl-banner dl-banner--error">
              <mat-icon>error</mat-icon>
              {{ usersError }}
            </div>

            <!-- Users List -->
            <div *ngIf="!usersLoading && !usersError" class="users-list">
              <!-- Non-tenant partner: user accounts are provisioned per tenant, so there is
                   nothing this endpoint could ever return. -->
              <app-empty-state
                *ngIf="usersNotTenant"
                icon="info_outline"
                title="This partner is not a tenant">
                User accounts are provisioned per tenant, so there are none to show. Create a
                tenant for this partner before adding users.
              </app-empty-state>

              <app-empty-state *ngIf="!usersNotTenant && users.length === 0" icon="people_outline">No users yet — use <strong>Add User</strong> to create the first one.</app-empty-state>

              <div *ngIf="users.length > 0 || pendingInvitations.length > 0" class="users-table">
                <table class="dl-table dl-table--cards" dlCardTable>
                  <thead>
                    <tr>
                      <th>Name</th>
                      <th>Email</th>
                      <th>Role</th>
                      <th>Status</th>
                      <th>Joined</th>
                      <th>Last active</th>
                    </tr>
                  </thead>
                  <tbody>
                    <!-- Asked, not yet answered. In the same table as everybody else, because a
                         pending invitation holds one of this tenant's seats and is the only trace
                         of an address somebody typed. No name or photo: until they accept, there
                         is no member to describe. -->
                    <tr *ngFor="let invitation of pendingInvitations" class="pending-row">
                      <td class="user-name muted">—</td>
                      <td class="user-email">
                        <a *ngIf="invitation.email" [href]="'mailto:' + invitation.email">{{ invitation.email }}</a>
                        <span *ngIf="!invitation.email" class="muted">—</span>
                      </td>
                      <td>
                        <span class="user-role" [class]="getUserRoleClass(invitation.role)">
                          {{ getUserRoleLabel(invitation.role) }}
                        </span>
                      </td>
                      <td>
                        <span class="user-status status-pending">Invited</span>
                        <span class="pending-actions">
                          <button class="dl-btn dl-btn--sm" [disabled]="invitationBusyId === invitation.id"
                                  (click)="resendInvitation(invitation)">Send again</button>
                          <button class="dl-btn dl-btn--ghost dl-btn--sm"
                                  [disabled]="invitationBusyId === invitation.id"
                                  (click)="withdrawInvitation(invitation)">Withdraw</button>
                        </span>
                      </td>
                      <td class="muted">—</td>
                      <td class="muted" [title]="'Expires ' + (invitation.expiresAt | date:'medium')">
                        expires {{ invitation.expiresAt | date:'shortDate' }}
                      </td>
                    </tr>
                    <tr *ngFor="let user of users">
                      <td class="user-name">{{ user.name || 'Unknown User' }}</td>
                      <td class="user-email">
                        <a *ngIf="user.email" [href]="'mailto:' + user.email">{{ user.email }}</a>
                        <span *ngIf="!user.email" class="muted">—</span>
                      </td>
                      <td>
                        <span class="user-role" [class]="getUserRoleClass(user.role)">
                          {{ getUserRoleLabel(user.role) }}
                        </span>
                        <!-- Where that role came from. Identical-looking roles behave identically
                             today and differently the day the fallback is switched off, so the
                             console says which is which rather than letting them look the same. -->
                        <span *ngIf="!user.membershipRole" class="user-role-source"
                              title="No membership row: this role still comes from their Keycloak account, and they lose access to this tenant when KEYCLOAK_ROLE_FALLBACK is switched off.">
                          from Keycloak
                        </span>
                      </td>
                      <td>
                        <span class="user-status" [class]="getUserStatusClass(user)">
                          {{ getUserStatusLabel(user) }}
                        </span>
                      </td>
                      <td [title]="formatAbsolute(user.createdAt)">
                        <span *ngIf="user.createdAt">{{ user.createdAt | date:'mediumDate' }}</span>
                        <span *ngIf="!user.createdAt" class="muted">—</span>
                      </td>
                      <td [title]="lastActiveTooltip(user)">
                        <span *ngIf="user.lastActiveAt">{{ formatRelative(user.lastActiveAt) }}</span>
                        <span *ngIf="!user.lastActiveAt" class="muted">Never</span>
                      </td>
                    </tr>
                  </tbody>
                </table>

                <p *ngIf="usersWithoutMembershipRow > 0" class="users-note users-note--warn">
                  {{ usersWithoutMembershipRow }} of {{ users.length }} still have no membership
                  row, so their role comes from their Keycloak account. Run
                  <code>scripts/import-memberships.sh</code> before switching
                  <code>KEYCLOAK_ROLE_FALLBACK</code> off for this environment.
                </p>

                <p class="users-note">
                  Last login comes from Keycloak sessions and login events. Sign-ins from before
                  login-event logging was enabled are not recorded and show as “Never”.
                </p>
              </div>
            </div>
          </div>
        </div>

        <!-- Cases Tab -->
        <div *ngIf="activeTab === 'cases' && shouldShowCases()" class="pd-tab-panel">
          <!-- Partner Cases Card -->
          <div class="dl-card pd-card">
            <div class="dl-card__header">
              <h2 class="dl-card__title">Partner Cases</h2>
            </div>

            <!-- Cases Loading -->
            <div *ngIf="casesLoading" class="cases-loading">
              <div class="dl-spinner"></div>
              <p>Loading cases...</p>
            </div>

            <!-- Cases Error -->
            <div *ngIf="casesError" class="dl-banner dl-banner--error">
              <mat-icon>error</mat-icon>
              {{ casesError }}
            </div>

            <!-- Cases List -->
            <div *ngIf="!casesLoading && !casesError" class="cases-list">
              <app-empty-state *ngIf="cases.length === 0" icon="folder_open">No cases found for this partner.</app-empty-state>

              <div *ngIf="cases.length > 0">
                <!-- Cases Table -->
                <div class="cases-table">
                  <table class="dl-table dl-table--cards" dlCardTable>
                    <thead>
                      <tr>
                        <th>Case ID</th>
                        <th>Patient Name</th>
                        <th>Created At</th>
                        <th>Status</th>
                        <th>Doctor</th>
                        <th>Tech</th>
                        <th>Actions</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr *ngFor="let case of cases" class="case-row" (click)="viewCaseDetails(case)" style="cursor: pointer;">
                        <td>{{ case.id || 'N/A' }}</td>
                        <td>{{ case.patient?.name || 'N/A' }}</td>
                        <td>{{ case.createdAt ? (case.createdAt | date:'short') : 'N/A' }}</td>
                        <td>
                          <span class="case-status" [class]="getCaseStatusClass(case.status || '')">
                            {{ case.status || 'Unknown' }}
                          </span>
                        </td>
                        <td class="partner-name" (click)="$event.stopPropagation()">
                          <a 
                            *ngIf="case.doctor?.id" 
                            [routerLink]="['/partners', case.doctor?.id]" 
                            class="partner-link">
                            {{ getDoctorName(case) }}
                          </a>
                          <span *ngIf="!case.doctor?.id">
                            {{ getDoctorName(case) }}
                          </span>
                        </td>
                        <td class="partner-name" (click)="$event.stopPropagation()">
                          <a 
                            *ngIf="case.tech?.id" 
                            [routerLink]="['/partners', case.tech?.id]" 
                            class="partner-link">
                            {{ getTechName(case) }}
                          </a>
                          <span *ngIf="!case.tech?.id">
                            {{ getTechName(case) }}
                          </span>
                        </td>
                        <td class="actions" (click)="$event.stopPropagation()">
                          <button 
                            class="dl-btn dl-btn--danger-ghost dl-btn--icon dl-btn--sm" 
                            (click)="askDeleteCase(case)" 
                            title="Delete Case">
                            <mat-icon>delete</mat-icon>
                          </button>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>

                <!-- Pagination -->
                <app-pagination
                  [currentPage]="casesPage"
                  [pageSize]="casesSize"
                  [totalElements]="casesTotalElements"
                  [totalPages]="casesTotalPages"
                  itemLabel="cases"
                  (pageChange)="goToCasesPage($event)">
                </app-pagination>
            </div>
          </div>
        </div>

        <!-- Shipments Tab -->
        <div *ngIf="activeTab === 'cases' && shouldShowShipments()" class="pd-tab-panel">
          <!-- Partner Shipments Card -->
          <div class="dl-card pd-card">
            <div class="dl-card__header">
              <h2 class="dl-card__title">Partner Shipments</h2>
            </div>

            <!-- Shipments Loading -->
            <div *ngIf="shipmentsLoading" class="shipments-loading">
              <div class="dl-spinner"></div>
              <p>Loading shipments...</p>
            </div>

            <!-- Shipments Error -->
            <div *ngIf="shipmentsError" class="dl-banner dl-banner--error">
              <mat-icon>error</mat-icon>
              {{ shipmentsError }}
            </div>

            <!-- Shipments List -->
            <div *ngIf="!shipmentsLoading && !shipmentsError" class="shipments-list">
              <app-empty-state *ngIf="shipments.length === 0" icon="local_shipping">No shipments found for this partner.</app-empty-state>

              <div *ngIf="shipments.length > 0">
                <!-- Shipments Table -->
                <div class="shipments-table">
                  <table class="dl-table dl-table--cards" dlCardTable>
                    <thead>
                      <tr>
                        <th>Shipment ID</th>
                        <th>Tracking Number</th>
                        <th>Created At</th>
                        <th>Status</th>
                        <th>From</th>
                        <th>To</th>
                        <th>Est. Delivery</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr *ngFor="let shipment of shipments">
                        <td>{{ shipment.id || 'N/A' }}</td>
                        <td class="tracking-number">{{ shipment.orderNumber || 'N/A' }}</td>
                        <td>{{ shipment.createdAt ? (shipment.createdAt | date:'short') : 'N/A' }}</td>
                        <td>
                          <span class="shipment-status" [class]="getShipmentStatusClass(shipment.status || '')">
                            {{ shipment.status || 'Unknown' }}
                          </span>
                        </td>
                        <td class="address">{{ shipment.from ? (shipment.from.street + ', ' + shipment.from.city) : 'N/A' }}</td>
                        <td class="address">{{ shipment.to ? (shipment.to.street + ', ' + shipment.to.city) : 'N/A' }}</td>
                        <td>{{ shipment.eta ? (shipment.eta | date:'short') : 'N/A' }}</td>
                      </tr>
                    </tbody>
                  </table>
                </div>

                <!-- Pagination -->
                <app-pagination
                  [currentPage]="shipmentsPage"
                  [pageSize]="shipmentsSize"
                  [totalElements]="shipmentsTotalElements"
                  [totalPages]="shipmentsTotalPages"
                  itemLabel="shipments"
                  (pageChange)="goToShipmentsPage($event)">
                </app-pagination>
            </div>
          </div>
        </div>

      </div>
    </div>


  </div>
</div>

<app-confirm-dialog
  [isOpen]="pendingDelete !== null"
  title="Delete case"
  [message]="'Case #' + (pendingDelete?.id || '') + ' will be removed permanently. This cannot be undone.'"
  confirmLabel="Delete case"
  confirmClass="dl-btn--danger"
  [busy]="deletingCase"
  (confirm)="confirmDeleteCase()"
  (cancel)="pendingDelete = null">
</app-confirm-dialog>
